<template>
    <div class="flex flex-col items-center justify-center flex-1 content-stretch ">
        <div class="flex-1">&nbsp;</div>
        <slot/>
        <div class="flex-2">&nbsp;</div>
    </div>
</template>
<script>
export default {
    
}
</script>
<style lang="scss" scoped>

</style>